import React from "react";
import { Modal, Image} from "antd";
import "./ShoutoutRecommendedRulesModal.css";

export default function ShoutoutRecommendedRulesModal({isOpen, onCloseCallback}) {
    return <Modal
        title="Shoutout Background Recommendations"
        open={isOpen}
        onCancel={onCloseCallback}
        onOk={onCloseCallback}
        centered
        width="600px"
        // Animation changes so it pops in from middle rather than from the originally clicked button
        className="center-animation-modal"
        maskTransitionName=""
        transitionName=""
        cancelButtonProps={{ style: { display: 'none' } }} // Hide cancel button
    >
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Image
                preview={false}
                style={{ objectFit: "contain", maxWidth: '400px' }}
                src={"https://graphics.getculturebot.com/other/custom-shoutout-background-instructions.png"}
            />
        </div>
        <div>When creating your custom shoutout graphic, keep in mind a few key things:</div>
        <div style={{ marginTop: "20px" }}></div>
        <div>1. This is generally where you should place the name of your shoutout type. You may also want to include a custom visual that matches the shoutout type.</div>
        <div>2. This area should be kept open, as it's where names and profile pictures of users shouted out will appear.</div>
        <div>3. This area should also be kept open, as it's where the text of the actual shoutout being sent will appear.</div>
        <div style={{ marginTop: "20px" }}></div>
        <div>Keep in mind the graphic should be exactly 1500 x 700 pixels in dimensions. The left 2/3 of the graphic should be kept completely open for it to be visually pleasing.</div>
    </Modal>
};
